// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_aIZGw","wrapper":"wrapper_xo9MW","slide-title":"slide-title_a6nfQ"};